import { render } from "./ModalFilterShipment.vue?vue&type=template&id=634a309b&scoped=true"
import script from "./ModalFilterShipment.vue?vue&type=script&lang=js"
export * from "./ModalFilterShipment.vue?vue&type=script&lang=js"

import "./ModalFilterShipment.vue?vue&type=style&index=0&id=634a309b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634a309b"]])

export default __exports__